<div class="main-home-section">
  <app-navbar></app-navbar>

  <div class="our-story-container">
    <div class="left">
      <h1>
        Lyssa deHart, MCC–MENTOR COACH, AUTHOR & COACHING LEADER
      </h1>

      <p class="description">
        A leading voice in modern coaching, Lyssa blends neuroscience, deep listening, and reflective practice
        to help coaches master the ICF Core Competencies. Lyssa is the host The Coaching Studio Podcast, where she
        engages in thought-provoking conversations with thought leaders in the coaching and psychology profession. 
        
        
        She
        has trained over <strong>7,500 coaches worldwide</strong>
        and continues to elevate the coaching profession through her books, programs, and mentorship. Beyond her work in
        coach education, Lyssa has collaborated with leaders across diverse industries including the military,
        technology, insurance, finance, healthcare, and small businesses as a Leadership and Confidence Coach.
        Her approach blends science, inquiry, partnership, and strategic insight, helping both individuals and organizations cultivate creative, adaptive leadership. Through all her endeavors, she remains committed to elevating the quality and impact of coaching worldwide.
      </p>

      <div class="cta-buttons">
        <button class="cta-btn primary" routerLink="/program-page">
          Become a Coach
        </button>

        <button class="cta-btn ebook">
          <a href="../../../assets/coaching e-book.pdf" target="_blank" class="ebook-link">
            Download Free e-Book
          </a>
        </button>
      </div>
    </div> <!-- end .left -->

    <div class="video-container">
      <iframe src="https://www.youtube.com/embed/IYxZt0pzBAo?si=XLa8ZqSkBmNeRJXC&autoplay=0&rel=0&modestbranding=1"
        frameborder="0" allowfullscreen
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">
      </iframe>
    </div>
  </div>


  <div class="ticker">
    <app-vertual (registerClicked)="openPopupFromVertual($event)"></app-vertual>
  </div>

</div>

<!-- Video Popup Overlay -->
<div class="video-popup-overlay" *ngIf="showVideoPopup" (click)="closeVideoPopup()">
  <div class="video-popup-box" (click)="$event.stopPropagation()">
    <button class="close-btn" (click)="closeVideoPopup()">&times;</button>

    <!-- Video Player -->
    <iframe *ngIf="popupVideoUrl" [src]="popupVideoUrl" frameborder="0" allowfullscreen>
    </iframe>

    <!-- Tabs Section -->
    <div class="video-tabs">
      <button [class.active]="activeTab === 'overview'" (click)="activeTab = 'overview'">Overview</button>
      <button [class.active]="activeTab === 'faq'" (click)="activeTab = 'faq'">Prerequisites & FAQs</button>
    </div>

    <!-- Video Info Section -->
    <div class="video-info" *ngIf="activeTab === 'overview'">
      <h2>{{ selectedVideo?.title }}</h2>
      <p>{{ selectedVideo?.description }}</p>
    </div>

    <div class="video-info" *ngIf="activeTab === 'faq'">
      <h3>Prerequisites & FAQs</h3>
      <p>Coming soon...</p>
    </div>
  </div> <!-- end .video-popup-box -->
</div> <!-- end .video-popup-overlay -->



<!-- Registration Popup -->
<div class="popup-overlay" *ngIf="showPopup">
  <div class="popup-box">
    <div class="popup-content">
      <!-- Header -->
      <h2 class="popup-title">{{ selectedSession?.title }}</h2>

      <!-- Date & Time -->
      <div class="session-info">
        <p><strong>Date & Time:</strong>
          {{ selectedSession?.sessions[0]?.date | date: 'MMM d, y' }}
          {{ selectedSession?.sessions[0]?.startTime }} ({{ selectedSession?.sessions[0]?.timezone || 'EST' }})
        </p>
        <p><strong>Description:</strong> {{ selectedSession?.description }}</p>
      </div>

      <hr />

      <!-- Registration Form -->
      <div class="registration-section">
        <h4>Meeting Registration</h4>

        <div class="form-row">
          <div class="form-group">
            <label>First Name <span class="required">*</span></label>
            <input [(ngModel)]="firstName" type="text" placeholder="Enter first name" />
          </div>

          <div class="form-group">
            <label>Last Name <span class="required">*</span></label>
            <input [(ngModel)]="lastName" type="text" placeholder="Enter last name" />
          </div>
        </div>

        <div class="form-group full-width">
          <label>Email Address <span class="required">*</span></label>
          <input [(ngModel)]="email" type="email" placeholder="Enter email address" />
        </div>
      </div>

      <p class="privacy-note">
        Information you provide when registering will be shared with the
        <a href="#">account owner</a> and host and can be used and shared by them
        in accordance with their Terms and Privacy Policy.
      </p>

      <!-- Action Button -->
      <div class="popup-footer">
        <button class="register-btn" (click)="registerForSession()">Register</button>
      </div>
    </div>

    <!-- Close Button -->
    <button class="close-btn" (click)="closePopup()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>
</div>